var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg62(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upper right arrow / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.918 6.62C17.8165 6.37565 17.6223 6.18147 17.378 6.08C17.2578 6.02876 17.1287 6.00158 16.998 6H6.99799C6.73277 6 6.47842 6.10536 6.29088 6.29289C6.10334 6.48043 5.99799 6.73478 5.99799 7C5.99799 7.26522 6.10334 7.51957 6.29088 7.70711C6.47842 7.89464 6.73277 8 6.99799 8H14.588L6.28799 16.29C6.19426 16.383 6.11986 16.4936 6.06909 16.6154C6.01833 16.7373 5.99219 16.868 5.99219 17C5.99219 17.132 6.01833 17.2627 6.06909 17.3846C6.11986 17.5064 6.19426 17.617 6.28799 17.71C6.38095 17.8037 6.49155 17.8781 6.61341 17.9289C6.73527 17.9797 6.86597 18.0058 6.99799 18.0058C7.13 18.0058 7.2607 17.9797 7.38256 17.9289C7.50442 17.8781 7.61502 17.8037 7.70799 17.71L15.998 9.41V17C15.998 17.2652 16.1033 17.5196 16.2909 17.7071C16.4784 17.8946 16.7328 18 16.998 18C17.2632 18 17.5176 17.8946 17.7051 17.7071C17.8926 17.5196 17.998 17.2652 17.998 17V7C17.9964 6.86932 17.9692 6.74022 17.918 6.62Z",
    fill: "#64ABA1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg62);
export default __webpack_public_path__ + "static/media/svg62.d322d423f3b69ce86d2b799f0f3dc86a.svg";
export { ForwardRef as ReactComponent };